// ─── Shop closed / out of office ──────────────────────────────
// Flip ORDERS_CLOSED to true to disable the order page.
// Set ORDERS_RETURN_DATE to the date orders reopen (shown to customers).
// Remember to set ORDERS_CLOSED back to false when you return!
export const ORDERS_CLOSED = false;
export const ORDERS_RETURN_DATE = "May 11";

// ─── Pickup windows ────────────────────────────────────────────
// Update times here if your schedule changes.
export const PICKUP_WINDOWS = [
  { id: "sat-am", label: "Saturday 10:00 AM – 12:00 PM" },
  { id: "sat-pm", label: "Saturday 4:00 PM – 6:00 PM" },
  { id: "sun-am", label: "Sunday 10:00 AM – 12:00 PM" },
  { id: "sun-pm", label: "Sunday 4:00 PM – 6:00 PM" },
];

// ─── Flavors ───────────────────────────────────────────────────
// Used by the Admin inventory manager panel.
// Add new flavors here as you expand.
export const FLAVORS = [
  { id: "vanilla",         name: "Vanilla"         },
  { id: "strawberry",      name: "Strawberry"      },
  { id: "lemon",           name: "Lemon"           },
  { id: "espresso",        name: "Espresso"        },
  { id: "peppermint",      name: "Peppermint"      },
  { id: "peach",           name: "Peach"           },
  { id: "toasted-coconut", name: "Toasted Coconut" },
];
